import Chart from 'react-apexcharts';

interface IGroupedStackedBarChartProps {
	chartData: any[];
	chartOptions: any;
}

const GroupedStackedBarChart = (props: IGroupedStackedBarChartProps) => {
	const { chartData, chartOptions } = props;
	return (
		<Chart
			options={chartOptions}
			series={chartData}
			type='bar'
			height={350}
		/>
	);
};

export default GroupedStackedBarChart;
